import { render, staticRenderFns } from "./Mitra.vue?vue&type=template&id=a9261522"
import script from "./Mitra.vue?vue&type=script&lang=js"
export * from "./Mitra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports